import { Frame } from '~/lib/data-contract/auto-generated/api-model';
import { Product, ProductResult } from '~/lib/data-contract/salesforce';
import { CommerceApiContext } from '../../lib/data-contract/salesforce';
import { GetProductOptions, GetProductsOptions, SFProduct } from './pdp.definitions';

export const getProducts = async (api: CommerceApiContext, parameters: GetProductsOptions) => {
    console.time('getProducts');
    const result = (await api.shopperProducts?.getProducts({ parameters })) as ProductResult;
    console.timeEnd('getProducts');
    return result;
};

export const getProduct = async (
    api: CommerceApiContext,
    parameters: GetProductOptions
): Promise<Product | undefined> => {
    console.time('getProduct');
    const result = (await api.shopperProducts?.getProduct({ parameters })) as Product | undefined;
    console.timeEnd('getProduct');
    return result;
};

export const getProductWithVariants = (
    api: CommerceApiContext,
    parameters: GetProductsOptions
): Promise<{ product: SFProduct | null; variants: SFProduct[] | null }> => {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (res, rej) => {
        try {
            const response = await getProducts(api, parameters);
            if (response && response.data?.length > 0) {
                const product = response.data[0];

                const variantIDs =
                    product &&
                    product.variants?.map((v) => v.productId).filter((v) => v !== product.id);

                const variants = await getProducts(api, {
                    locale: parameters.locale,
                    ids: variantIDs?.join(',') ?? '',
                });

                res({
                    product,
                    variants: variants?.data ? variants.data : null,
                });
            }
            return null;
        } catch (e) {
            console.error(e);
            rej(e);
        }
    });
};
export const getPDPUrl = (frame: Frame, fallbackUrl: string) =>
    frame.settings?.pageReferences.productPage?.url ?? fallbackUrl;

export const getPDPParams = (product: SFProduct) => ({
    seriesId: product.c_ProductSeries,
    brandid: product.brand,
    subCategoryId: product.c_ProductMainCategory,
    categoryId: product.c_ProductParentCategory,
});
